import { IPageConfig } from "../../types";

let config: IPageConfig = {
    geoBaseDistance: 0.8,
    geoNumRange: [2, 6],
    geoValueRange: [0, 90],
    geoBasePosY: 2,
    cameraPosZ: 16,
    animationSpeed: 400,
}


export default config;